// extracted by mini-css-extract-plugin
export default {"select":"order-table_select__ezArK"};